(function () {
  'use strict';

  angular
    .module('usuarios')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('root.usuarios', {
        url: '/usuarios?vfiltro=',
        views: {
          'content@': {
            templateUrl: 'usuarios/usuarios.tpl.html',
            controller: 'UsuariosCtrl',
            controllerAs: 'usuarios'
          }
        },
        data: {
          titulo: 'core-permissoes.organizacao.usuarios.title',
          role: 'USUARIO_VISUALIZAR'
        }
      });
  }
}());
